import classNames from "classnames";

import type { ListConfig } from "../../blockTypes";
import TextBlock from "./TextBlock";

interface ListBlockProps {
    config?: ListConfig;
}

const ListBlock = ({ config }: ListBlockProps) => {
    // Bad data from the CMS (items missing or not a list) renders nothing instead of crashing
    const rawItems = config?.items;
    const items = Array.isArray(rawItems) ? rawItems : [];

    if (items.length === 0) return null;

    const ordered = config?.ordered === true;
    const ListTag = ordered ? "ol" : "ul";

    return (
        <ListTag
            className={classNames(
                "list-inside space-y-2 text-gray-800",
                ordered ? "list-decimal" : "list-disc"
            )}
        >
            {items.map((item, index) => (
                <li key={index} className="leading-7">
                    <TextBlock config={{ text: item }} />
                </li>
            ))}
        </ListTag>
    );
};

export default ListBlock;